import { render, staticRenderFns } from "./Clean.vue?vue&type=template&id=6cf6097c&scoped=true&"
import script from "./Clean.vue?vue&type=script&lang=js&"
export * from "./Clean.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf6097c",
  null
  
)

export default component.exports